import React, { Component } from 'react';
import InspectionListMobile from './components/InspectionListMobile';
import InspectionList from './components/InspectionList';

import MediaQuery from 'react-responsive';

export default class Inspections extends Component {
  render() {
    return (
      <div className="body" role="main">
        <div className="centers">
          <div style={{ height: '100%' }}>
            <MediaQuery query="(min-device-width: 750px)">
              <InspectionList />
            </MediaQuery>

            <MediaQuery query="(max-device-width: 750px)">
              <InspectionListMobile />
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
